var map = {
	"./de/general12/slide1.svg": 383222,
	"./en/general12/slide1.svg": 157562,
	"./es/general12/slide1.svg": 53861,
	"./fr/general12/slide1.svg": 403149,
	"./nl/general12/slide1.svg": 977047,
	"./pt/general12/slide1.svg": 449169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41362;